import { render } from "./PipDescription.vue?vue&type=template&id=4ff75abd"
import script from "./PipDescription.vue?vue&type=script&lang=js"
export * from "./PipDescription.vue?vue&type=script&lang=js"

import "./PipDescription.vue?vue&type=style&index=0&id=4ff75abd&lang=scss"

import exportComponent from "/home/rubb/NiwCaetano/Frontend/governance/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__